module.exports = __webpack_public_path__ + "img/poster.276d5419.png";